(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('dispatchPlanningOrderLines', {
        templateUrl: 'views/components/views/dispatchPlanningOrderLines/dispatchPlanningOrderLines.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'translateService', 'dispatchPlanningOrderLinesService', 'consignmentPlansOrdersService', function ($stateParams, translateService, dispatchPlanningOrderLinesService, consignmentPlansOrdersService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;
            let resizing = false;
            let editing = false;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                mconfig: {
                    enabled: true,
                    show: true,
                    activate: function (item) {
                        if (item === 'all') {
                            vm.model.mconfig.records.forEach((data) => {
                                if (data) {
                                    if (data.canActive === true) {
                                        data.isActive = true;
                                    }
                                }
                            });
                        } else if (item && item.item_id) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else if (item) {
                            for (let r = 0; r < vm.model.mconfig.records.length; r++) {
                                if (vm.model.mconfig.records[r].item_name === item && vm.model.mconfig.records[r].canActive === true) {
                                    vm.model.mconfig.records[r].isActive = true;
                                    break;
                                }
                            }
                        }
                    },
                    deactivate: function (item) {                    
                        if (item === 'all') {
                            vm.model.mconfig.records.forEach((data) => {
                                if (data) {
                                    if (data.item_name === 'resize' && data.isActive) {
                                        resizeColumn();
                                    }

                                    if (data.canActive === true) {
                                        data.isActive = false;
                                    }
                                }
                            });
                        } else if (item && item.item_id) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else if (item) {
                            for (let r = 0; r < vm.model.mconfig.records.length; r++) {
                                if (vm.model.mconfig.records[r].item_name === item) {
                                    vm.model.mconfig.records[r].isActive = false;
                                    break;
                                }
                            }
                        }
                    },
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }
                        
                        /* RESIZING COLUMNS */
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                resizeColumn();
                            }
                        }
                    },
                    records: [
                        { item_id: '0', item_name: 'option', glyph: 'glyphicon-option-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, enabled: true, show: false },
                        { item_id: '2', item_name: 'plus', glyph: 'glyphicon-plus', color: 'primary', show: false },
                        { item_id: '3', item_name: 'minus', glyph: 'glyphicon-minus', color: 'primary', show: false },
                        { item_id: '4', item_name: 'trash', glyph: 'glyphicon-trash', color: 'primary', show: false },
                        { item_id: '5', item_name: 'sort', glyph: 'glyphicon-sort', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: true, show: false },
                        { item_id: '6', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '7', item_name: 'edit', glyph: 'fa-edit', color: 'primary', colorActive: 'warning', canActive: true, isActive: true, isIcon: false, enabled: true, show: false },
                        { item_id: '10', item_name: 'uncheck', glyph: 'glyphicon-unchecked', color: 'primary', show: false },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: false }
                    ]
                },
                itemsListOrderLines: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadOrderLines() {
                dispatchPlanningOrderLinesService.listOrderLines({
                    argtype: argType,
                    argvalue: argValue
                }).then((list) => {
                    let smallDataLoad = [];

                    for (let i = 0; i < list.length; i++) {
                        list[i].item_id = illegalCharRegExp(list[i].item_id);
                        smallDataLoad.push(list[i]);
                    }

                    vm.model.itemsListOrderLines = smallDataLoad;
                });
            }
            
            function resizeColumn() {
                for (let m = 0; m < vm.model.mconfig.records.length; m++) {
                    if (vm.model.mconfig.records[m] && vm.model.mconfig.records[m].item_id === '99') {
                        vm.model.mconfig.records[m].animate = true;
                        break;
                    }
                }
                
                let updateList = [];
                
                if (vm.model.itemsListOrderLines[0] && vm.model.itemsListOrderLines[0].item_secondary) {
                    for (let r = 0; r < vm.model.itemsListOrderLines[0].item_secondary.length; r++) {
                        if (r === 0) {
                            updateList.push({
                                item_id: r,
                                item_col_width: vm.model.itemsListOrderLines[0].item_col_width
                            })
                        }

                        if (vm.model.itemsListOrderLines[0].item_secondary[r]) {
                            updateList.push({
                                item_id: r + 1,
                                item_col_width: vm.model.itemsListOrderLines[0].item_secondary[r].item_col_width
                            })
                        }
                    }
                }
                
                let updateParms = {
                    view_id: 'dispatchplanning.orderlines.list',
                    records: updateList
                };
                
                consignmentPlansOrdersService.updateColumnResize(updateParms).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                }
                            }]
                        });
                    } else {
                        for (let m = 0; m < vm.model.mconfig.records.length; m++) {
                            if (vm.model.mconfig.records[m] && vm.model.mconfig.records[m].item_id === '99') {
                                vm.model.mconfig.records[m].animate = false;
                                break;
                            }
                        }
                        
                        setTimeout(() => {
                            vm.model.mconfig.records[m].animate = null;
                        }, 2000);
                    }
                    
                    resizing = false;
                });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REGULAR EXPRESSION CHECK FUNCTION

            function illegalCharRegExp(str) {
                return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "-");
            }

            // #endregion REGULAR EXPRESSION CHECK FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadOrderLines();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
